import moment from 'moment';

export const HEADER = [
  {title:"No."},
  {title:"Created At"},
  {title:"User Details"},
  {title:"Contacts"},
  {title:"Status"},
  {title:"Action"},
];

export const DATA_TYPES = [
  {eventKey: "all", label: "All", convert: value => value},
  {eventKey: "createdAt", label: "Created Date", convert: value => moment(value).format('D MMMM YYYY')},
  {eventKey: "email", label: "Email", convert: value => value},
  {eventKey: "name", label: "Full Name", convert: value => value},
  {eventKey: "mobile", label: "Mobile Number", convert: value => value},
  {eventKey: "mobileVerified", label: "Mobile Verify", convert: value => `${value}`},
  {eventKey: "nric", label: "NRIC", convert: value => value},
  {eventKey: "profileID", label: "Profile ID", convert: value => value},
  {eventKey: "status", label: "Result Status", convert: value => value},
  {eventKey: "userID", label: "User ID", convert: value => value},
];

export const SORT_DATA_TYPES = [
  {eventKey: "newestDate", label: "Date: Newest", convert: value => value},
  {eventKey: "oldestDate", label: "Date: Oldest", convert: value => value},
  {eventKey: "ascName", label: "Name: Ascending", convert: value => value},
  {eventKey: "descName", label: "Name: Descending", convert: value => value},
];



// WEBPACK FOOTER //
// ./src/const/mobileVeriyLists.js